function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2.5rem 1.25rem;\n  margin: 1.25rem auto; // Center horizontally\n  border: 1px dashed ",
        ";\n  border-radius: 0.5rem;\n  background-color: ",
        ";\n  text-align: center;\n  color: ",
        ";\n  width: fit-content; // Adjust width to content\n  min-width: 250px; // Minimum width\n  max-width: 90%; // Maximum width relative to parent\n  transition: all ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1.25rem;\n  color: ",
        ";\n\n  svg {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; // 14px\n  line-height: 1.25rem; // 20px\n  max-width: 400px;\n  white-space: pre-line; // Changed from pre-wrap to pre-line\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n  .animate-spin {\n    animation: spin 1s linear infinite;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Loader2 } from 'lucide-react';
import { Inbox } from 'lucide-react';
import { AlertCircle } from 'lucide-react';
var Wrapper = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.borderLight : '#e5e7eb';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.paperDark : '#f9fafb';
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.textSecondary : '#6b7280';
}, function(param) {
    var theme = param.theme;
    var _theme_transition;
    return (theme === null || theme === void 0 ? void 0 : (_theme_transition = theme.transition) === null || _theme_transition === void 0 ? void 0 : _theme_transition.normal) || '0.3s ease';
});
var IconWrapper = styled.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.textMuted : '#9ca3af';
});
var Text = styled.p(_templateObject2(), function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.isDark) ? theme.text : 'inherit';
});
var StatusDisplay = function(param) {
    var type = param.type, message = param.message, CustomIcon = param.icon, className = param.className, _param_compact = param.compact, compact = _param_compact === void 0 ? false : _param_compact;
    var theme = useTheme();
    var DefaultIconComponent = null;
    switch(type){
        case 'loading':
            DefaultIconComponent = Loader2;
            break;
        case 'empty':
            DefaultIconComponent = Inbox;
            break;
        case 'error':
            DefaultIconComponent = AlertCircle;
            break;
        case 'info':
            DefaultIconComponent = Inbox;
            break;
    }
    var IconToRender = CustomIcon || DefaultIconComponent;
    var iconClassName = type === 'loading' ? 'animate-spin' : '';
    var iconElement = IconToRender ? /*#__PURE__*/ React.createElement(IconToRender, {
        className: iconClassName
    }) : null;
    // Adjust styles for compact mode if needed
    var wrapperStyle = compact ? {
        padding: '1.5rem 1rem',
        margin: '0.5rem auto'
    } : {};
    var iconStyle = compact ? {
        marginBottom: '0.75rem'
    } : {};
    if (iconClassName.includes('animate-spin')) {
        iconStyle.animation = 'spin 1s linear infinite';
    }
    // Replace literal '\n' with actual newline character if necessary
    var processedMessage = React.useMemo(function() {
        if (typeof message === 'string') {
            return message.includes('\\n') ? message.replace(/\\n/g, '\n') : message;
        }
        return message;
    }, [
        message
    ]);
    return /*#__PURE__*/ React.createElement(Wrapper, {
        className: className,
        style: wrapperStyle,
        theme: theme
    }, iconElement && /*#__PURE__*/ React.createElement(IconWrapper, {
        style: iconStyle,
        theme: theme
    }, iconElement), typeof processedMessage === 'string' ? /*#__PURE__*/ React.createElement(Text, {
        theme: theme
    }, processedMessage) : /*#__PURE__*/ React.createElement(Text, {
        theme: theme,
        as: "div"
    }, processedMessage));
};
export default StatusDisplay;
// Add keyframes for spin animation if not globally defined
var GlobalStyles = styled.div(_templateObject3()); // You might include GlobalStyles in your main app layout instead
